// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2O4x0","load":"Spinner_load__3HJMl","spin":"Spinner_spin__1Yqq3"};